import type { ErrorHandler } from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { LoggerService } from '@core/logging';
import { TelemetryService } from './telemetry.service';

/**
 * Global error handler que catch toutes les erreurs non gerees.
 *
 * Pipeline :
 *   1. Forward a PostHog (no-op sans cle) via `captureException` — on veut
 *      la stack brute, scope global.
 *   2. Delegue au `LoggerService` pour la trace console.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly logger = inject(LoggerService);
  private readonly telemetry = inject(TelemetryService);

  handleError(error: unknown): void {
    // Unwrap Angular's wrapper if present
    const resolved = (error as { rejection?: unknown })?.rejection ?? error;
    this.telemetry.captureException(resolved, { source: 'GlobalErrorHandler' });
    this.logger.error('GlobalErrorHandler', resolved);
  }
}
